// This file was generated using `pay js:run gql-v1 --type=fragment --name=StripeLegalEntityIndividual --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument, GraphQlFragmentUnion} from '@sail/data';

import type {
  Exact,
  OpenapiLegalEntityIndividualObjectFieldType,
} from '@stripe-internal/data-v1/schema/types';
import type {V1PermissionToken} from '@stripe-internal/data-v1/types';
import {legalEntityAddressFragment} from './legalEntityAddressFragment';
import {legalEntityJapanAddressFragment} from './legalEntityJapanAddressFragment';

import type {LegalEntityAddressFragmentData} from './legalEntityAddressFragment';
import type {LegalEntityJapanAddressFragmentData} from './legalEntityJapanAddressFragment';

const doc = gql`
  fragment StripeLegalEntityIndividualFragment on OpenapiLegalEntityIndividual {
    address {
      ...LegalEntityAddressFragment
    }
    address_kana {
      ...LegalEntityJapanAddressFragment
    }
    address_kanji {
      ...LegalEntityJapanAddressFragment
    }
    dob {
      day
      month
      year
    }
    email
    first_name
    first_name_kana
    first_name_kanji
    id
    last_name
    last_name_kana
    last_name_kanji
    maiden_name
    object
    phone
    ssn_last_4_provided
  }

  ${legalEntityAddressFragment}
  ${legalEntityJapanAddressFragment}
`;

export const stripeLegalEntityIndividualFragment: StripeLegalEntityIndividualFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type StripeLegalEntityIndividualFragmentData = {
  readonly __typename: 'OpenapiLegalEntityIndividual';
  readonly email: string | null;
  readonly first_name: string | null;
  readonly first_name_kana: string | null;
  readonly first_name_kanji: string | null;
  readonly id: string;
  readonly last_name: string | null;
  readonly last_name_kana: string | null;
  readonly last_name_kanji: string | null;
  readonly maiden_name: string | null;
  readonly object: OpenapiLegalEntityIndividualObjectFieldType;
  readonly phone: string | null;
  readonly ssn_last_4_provided: boolean | null;
  readonly address: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiLegalEntityAddress'},
    [LegalEntityAddressFragmentData]
  > | null;
  readonly address_kana: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiLegalEntityJapanAddress'},
    [LegalEntityJapanAddressFragmentData]
  > | null;
  readonly address_kanji: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiLegalEntityJapanAddress'},
    [LegalEntityJapanAddressFragmentData]
  > | null;
  readonly dob: {
    readonly __typename: 'OpenapiLegalEntityDob';
    readonly day: number | null;
    readonly month: number | null;
    readonly year: number | null;
  } | null;
};

export type StripeLegalEntityIndividualFragmentVariables = Exact<{
  [key: string]: never;
}>;

const stripeLegalEntityIndividualFragmentPermissions = {
  ...legalEntityAddressFragment.permissions,
  ...legalEntityJapanAddressFragment.permissions,
} as const;

doc.permissions = stripeLegalEntityIndividualFragmentPermissions;

export type StripeLegalEntityIndividualFragmentPermissions = V1PermissionToken<
  typeof stripeLegalEntityIndividualFragmentPermissions
>;

export type StripeLegalEntityIndividualFragmentDocument = GraphQlDocument<
  StripeLegalEntityIndividualFragmentData,
  StripeLegalEntityIndividualFragmentVariables,
  StripeLegalEntityIndividualFragmentPermissions
>;
